import routesConfig from '../config/routes';

import NoLayout from '../layouts/NoLayout/NoLayout';

import NotFound from '../pages/NotFound/NotFound';
import Test from '../pages/Test/Test';
import Login from '../pages/Login';
import Home from '../pages/Home';
import About from '../pages/About/About';
import Skills from '../pages/Skills/Skills';
import Experience from '../pages/Experience/Experience';
import Projects from '../pages/Project/Projects';
import ProjectDetails from '../pages/Project/ProjectDetails';
import Contact from '../pages/Contact/Contact';


const publicRoutes = [
    { path: routesConfig.login, component: Login, layout: NoLayout },
    { path: routesConfig.notfound404, component: NotFound, layout: NoLayout },
    { path: routesConfig.test, component: Test, layout: NoLayout },
    { path: routesConfig.home, component: Home },
    { path: routesConfig.about, component: About },
    { path: routesConfig.skill, component: Skills },
    { path: routesConfig.experience, component: Experience },
    { path: routesConfig.projects, component: Projects },
    { path: routesConfig.projectDetail, component: ProjectDetails },
    { path: routesConfig.contact, component: Contact },
];

const privateRoutes = [
    // { path: routesConfig.home, component: Home, layout: NoLayout },
    // { path: routesConfig.home, component: Home },
   
];


export { publicRoutes, privateRoutes };
